import { AnimatedEllipsis } from '@/components/chat/AnimatedEllipsis';
import { Sparkles } from 'lucide-react';

export function AssistantLoading() {
  return (
    <div className="group flex gap-3">
      {/* Avatar */}
      <div className="flex-shrink-0">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-dc-accent-primary/20 to-dc-accent-secondary/20 ring-1 ring-dc-accent-primary/30">
          <img
            src={`${import.meta.env.BASE_URL}/daddycad-logo.png`}
            alt="DaddyCad"
            className="h-5 w-5"
          />
        </div>
      </div>

      {/* Message Content */}
      <div className="min-w-0 flex-1">
        {/* Header */}
        <div className="mb-2 flex items-center gap-2">
          <span className="text-sm font-semibold text-dc-text-primary">DaddyCad</span>
          <span className="flex items-center gap-1 rounded-full bg-dc-accent-primary/10 px-2 py-0.5 text-xs text-dc-accent-primary">
            <Sparkles className="h-3 w-3" />
            AI
          </span>
        </div>

        {/* Loading indicator */}
        <div className="rounded-2xl rounded-tl-md border border-dc-border-primary bg-dc-bg-tertiary/50 p-4 backdrop-blur-sm">
          <div className="flex items-center gap-3">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-dc-accent-primary/20 to-dc-accent-secondary/20 animate-pulse">
              <Sparkles className="h-4 w-4 text-dc-accent-primary" />
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-sm font-medium text-dc-text-primary">Thinking...</span>
              <AnimatedEllipsis color="accent" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
